import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeaturePermissions } from '@/lib/FeaturePermissionContext';

export default function FeatureRoute({ feature, children }) {
  const { loading, canUseFeature } = useFeaturePermissions();
  if (loading) return <div className="fixed inset-0 flex items-center justify-center bg-slate-50 dark:bg-slate-950"><div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin" /></div>;
  if (!canUseFeature(feature)) return <Navigate to="/" replace />;
  return children;
}
